import React from 'react';
import { Text } from '@airwallex/typography';
import { formatMoney } from '@/utils/formatPayment';
import Tooltip from '@airwallex/tooltip';
import { useTranslation } from 'react-i18next';

interface TaxTooltipProps {
  amount?: number;
  currency: string;
  effectiveTaxPercent?: number;
}

const TaxTooltip: React.FC<TaxTooltipProps> = ({ amount, currency, effectiveTaxPercent }) => {
  const { t } = useTranslation();
  const formattedAmount = formatMoney(amount ?? 0, currency);

  if (typeof effectiveTaxPercent !== 'number') {
    return <Text variant="body">{formattedAmount}</Text>;
  }

  const tooltipContent = t('invoice.salesTaxTooltip', {
    percent: parseFloat(effectiveTaxPercent.toFixed(2)),
  });

  return (
    <Tooltip body={<Text variant="body">{formattedAmount}</Text>} position="top">
      {tooltipContent}
    </Tooltip>
  );
};

export default TaxTooltip;
